import { Box, InputAdornment, OutlinedInput, Button, Dialog, DialogTitle, DialogContent, DialogActions, ClassNameMap, IconButton, Grid } from '@mui/material';
import SearchIcon from '../../../icons/searchIcon.svg';
import BackIcon from '../../../icons/backIcon.svg';
import { useEffect, useState } from 'react';

interface rolesProps {
  classes: ClassNameMap;
  selectRole(roleId: number): void;
  isOpen: boolean;
  initialRoleId?: number;
  dismiss(): void;
}

const roles = [
  { id: 1, value: 'Company Admin' },
  { id: 2, value: 'Property Manager' },
  { id: 3, value: 'Maintenance Coordinator' },
  { id: 4, value: 'Maintenance Staff' },
];

export default function RolesDialog(props: rolesProps) {
  const [selectedRoleId, setSelectedRoleId] = useState(props.initialRoleId || 0);

  useEffect(() => {
    if (!props.isOpen) {
      setSelectedRoleId(0);
    }else
      setSelectedRoleId(props.initialRoleId||0);

  }, [props.isOpen]);

  return (
    <Dialog
      PaperProps={{
        style: { borderRadius: 24 },
      }}
      id="rolesDialog"
      classes={{ paper: props.classes.dialogPaper }}
      BackdropProps={{ invisible: true }}
      open={props.isOpen}
      onClose={() => {}}
      className={props.classes.textField}
    >
      <DialogTitle sx={{ alignSelf: 'center', fontSize: 16, pt: '27px', justifyContent: 'flex-start', width: '100%', display: 'flex', '& p': { mt: 0, mb: 0, marginLeft: '180px' } }}>
        <IconButton
          sx={{ p: 0 }}
          onClick={() => {
            props.dismiss();
          }}
        >
          <img src={BackIcon} alt="cancel icon" width="14px" height="14px" />
        </IconButton>
        <p>Role</p>
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { mt: 3 },
            '& .MuiButton-root': { mt: 1 },
            '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
          }}
        >
          {/* search bar */}
          <OutlinedInput
            sx={{ height: 46, width: '100%', borderRadius: 24, backgroundColor: '#F1F0F5', borderColor: 'white' }}
            startAdornment={
              <InputAdornment position="start">
                <img
                  src={SearchIcon}
                  alt="search"
                  style={{
                    width: '15px',
                    height: '15px',
                  }}
                />
              </InputAdornment>
            }
          />
          <Box sx={{ mt: 2 }}>
            {roles.map((role) => {
              return (
                <Button
                  key={role.id}
                  fullWidth
                  variant="contained"
                  style={{
                    width: '100%',
                    height: '46px',
                    borderRadius: '24px',
                    textTransform: 'capitalize',
                    color: 'black',
                    backgroundColor: role.id === selectedRoleId ? '#A2DBFA' : '#F1F0F5',
                    borderColor: role.id === selectedRoleId ? '#A2DBFA' : '#F1F0F5',
                    fontFamily: 'Work Sans',
                    fontWeight: 400,
                    fontSize: '16px',
                    boxShadow: 'none',
                  }}
                  onClick={() => {
                    setSelectedRoleId(role.id);
                  }}
                >
                  {role.value}
                </Button>
              );
            })}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions className={props.classes.dialogActionButtons}>
        <Grid item display="flex" justifyContent="end" sx={{ width: '100%' }} mr={2}>
          <Button
            variant="accountManagement"
            onClick={() => {
              props.selectRole(selectedRoleId);
            }}
          >
            Continue
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
